import React, {Component} from 'react';
import {connect} from "react-redux";

import styled, {css} from "styled-components";

import {isMobile, getConfigurationLink} from "../../helpers/common";
import analytics from "../../helpers/analytics";

import ConfigEmailForm from "../ConfigEmailForm";
import ContactUsModal from "../ContactUsModal";

import {ReactComponent as WhatsappIcon} from '../../assets/img/whatsapp-icon.svg';


const Wrapper = styled.div`
  padding: 0 10px;
  border: 1px solid rgba(46, 44, 71, 0.31);
  border-radius: 2px;
`;

const Row = styled.div`
 
 padding: 15px 0;
 
 & + & {
    border-top: 1px solid rgba(46, 44, 71, 0.31);
 }
 
 ${props => props.verticalCenter && css`
    display: flex;
    align-items: center;
`}

`;

const Heading = styled.div`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
`;

const Text = styled.div`
  font-size: 13px;
  line-height: 16px;
  color: #666666;
`;

const Link = styled.span`
  font-size: 14px;
  line-height: 17px;
  color: #0080E2;
  cursor: pointer;
`;

const StyledConfigEmailForm = styled(ConfigEmailForm)`
  margin-bottom: 10px;
`;

const StyledWhatsappIcon = styled(WhatsappIcon)`
  width: 27px;
  height: 27px;
  margin-right: 3px;
`;

class ContactBox extends Component {

  state = {
    contactModalOpen: false
  };

  toggleContactModal = () => {

    const {contactModalOpen} = this.state;

    if (!contactModalOpen) {
      analytics.onContactModalOpened();
    }

    this.setState({
      contactModalOpen: !contactModalOpen
    });
  };

  onWhatsAppShare = (e) => {
    e.preventDefault();
    analytics.onWhatsAppShare();
    window.location = e.target.getAttribute('href');
  };

  render() {

    const {className, params} = this.props;
    const {contactModalOpen} = this.state;

    return (
      <Wrapper className={className}>

        <Row>
          <Heading>Link zur Konfiguration per E-Mail zusenden:</Heading>
          <StyledConfigEmailForm/>
          <Text>
            Wir schicken dir einen Link per E-Mail, über den du deine Konfiguration jederzeit öffnen kannst.
          </Text>
        </Row>

        {isMobile() &&
        <Row verticalCenter>
          <StyledWhatsappIcon/>
          <Link
            href={`https://api.whatsapp.com/send?text=${getConfigurationLink(params)}&utm_source=whatsapp&utm_medium=whatsapp&utm_campaign=shared_from_configurator`}
            onClick={this.onWhatsAppShare}
          >
            Tisch auf WhatsApp verschicken
          </Link>
        </Row>
        }

        <Row>
          <Link onClick={this.toggleContactModal}>Frage an den Steiger-Support stellen</Link>
          <ContactUsModal
            open={contactModalOpen}
            onClose={this.toggleContactModal}
          />
        </Row>

      </Wrapper>
    );
  }

}

export default connect(
  state => ({
    params: state.params
  })
)(ContactBox);

